<template class="page-content">
  <ModalLayout :ref="modalRef" :modalId="modalRef"
    :loading="isSavableStateLoading"
    @close="modalClosed">
    <template #modal-header>
      <h5 class="modal-title">
        Bulk Offer Transfer
      </h5>
    </template>
    <template #modal-body>
      <form @submit.prevent="saveAssignment">
        <fieldset>
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <MultiSelectInput v-model="selectedUser"
                  name="assignTo"
                  label="Assign To"
                  :options="users"
                  append-to="self"
                  label-key="name_to_display"
                  value-key="id"
                  col-style="form-group-5-column-large col-xl-5" />
              </div>
              <ActionToolbar :component-state="currentState" 
                toolbar-size="col-md-12"
                :primary-disabled="!selectedUser || isSavableStateLoading"
                success-message="Successfully updated!"
                primary-button-text="Update"
                secondary-button-text="Assign to me"
                tertiary-button-text="Unassign"
                secondary-style="primary"
                tertiary-style="danger"
                :secondary-enabled="true"
                :tertiary-enabled="true"
                @secondary-click="assignToSelf"
                @tertiary-click="unAssign"
                :error-message="formError" />
            </div>
          </div>
        </fieldset>
      </form>
    </template>
  </ModalLayout>
</template>

<script lang="js">
import ModalLayout from "@/src/components/shared/ModalLayout.vue";
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import {savableStateMixin} from "@/src/mixins/savableStateMixin";
import {modalActionsMixin} from "@/src/mixins/modalActionsMixin";
import PortalTable from "@/src/components/shared/PortalTable.vue";
import Column from 'primevue/column';
import MultiSelectInput from "@/src/components/shared/FormComponents/MultiSelectInput.vue";
import {useAppCoreStore} from "@/src/stores/app-core";
import { useMatchStore } from '@/src/stores/match';
import { useSuperTeamDashboardStore } from '@/src/stores/dashboards/super-team-dashboards';

export default {
  components: {
    PortalTable,
    ModalLayout,
    Column,
    ActionToolbar,
    MultiSelectInput
  },
  setup() {
    const superTeamDashboardStore = useSuperTeamDashboardStore();
    const appStore = useAppCoreStore();
    const matchStore = useMatchStore();
    return {
      superTeamDashboardStore, appStore, matchStore
    }
  },
  mixins: [savableStateMixin, modalActionsMixin],
  props: {
    matches: { required: true },
    users: { required: true },
  },
  emits: ['close', 'updated'],
  data() {
    return {
      selectedUser: null,
      modalRef: `bulk-assignments-modal`,
    }
  },
  methods: {
    modalClosed() {
      this.setSavableStateBlank();
      this.selectedUser = null;
      this.$emit('close');
    },
    async saveAssignment() {
      this.setSavableStateProcessing();
      const payload = {
        assigned_to_id: this.selectedUser,
        match_ids: this.matches.map((match) => match.id)
      }
      
      try {
        await this.matchStore.offersTransfer(payload);
        this.selectedUser = null;
        this.setSavableStateSuccess();
        this.$emit('updated');
      } catch(error) {
        this.handleFormError(error);
      }
    },
    async assignToSelf() {
      this.selectedUser = this.appStore.currentUser.profileInfo.id;
      this.saveAssignment();
    },
    unAssign() {
      this.selectedUser = null;
      this.saveAssignment();
    }
  }
}
</script>
<style>
  #bulk-assignments-modal .modal-body, .modal-content {
    overflow: visible !important;
  }
</style>
